exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ModalEdit[data-v-f63a7fc0] {\n  position: fixed;\n  z-index: 1;\n  padding-top: 100px;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: rgb(0, 0, 0);\n  background-color: rgba(0, 0, 0, 0.4);\n}\n#desactivadores[data-v-f63a7fc0] {\n  min-width: 1000px;\n  max-width: 500px;\n  width: 30%;\n}\n.desplegable[data-v-f63a7fc0] {\n  border-radius: 0;\n  z-index: 99999 !important;\n}\n", ""]);

// exports
